import React, { useMemo, useState } from 'react';

interface AccountManagementButtonProps {
  text: string;
  testId?: string;
  onClick?: () => void;
}

export const AccountManagementButton: React.FC<
  AccountManagementButtonProps
> = ({ text, testId, onClick = () => {} }) => {
  const [isClicked, setIsClicked] = useState(false);
  const isClickedClass = useMemo(
    () => (isClicked ? 'bg-light-3' : 'bg-white hover:bg-light-2'),
    [isClicked]
  );

  const handleOnClick = () => {
    setIsClicked((prev) => !prev);
    onClick();
  };

  return (
    <div
      className={`${isClickedClass} noto-13-medium w-[120px] cursor-pointer rounded-[5px] border border-dark-6 text-dark-4`}
      data-testid={testId}
      onClick={handleOnClick}
    >
      <p className="mx-5 my-[7px] text-center leading-[23px]">{text}</p>
    </div>
  );
};
